namespace GeniuzPOS.Purchase {
    export interface ReportPendingPRDtForm {
    }

    export class ReportPendingPRDtForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.ReportPendingPRDt';
    }
}
